define('glu/grid/header/tableHeader',['require','../../collectionView','../../dialog','../../util','../column/columnHeader','../comparatorFactory'],function(require) {
    'use strict';

    var CollectionView = require('../../collectionView'),
        dialog = require('../../dialog'),
        util = require('../../util'),
        HeaderView = require('../column/columnHeader'),
        comparatorFactory = require('../comparatorFactory');

    return CollectionView.extend({
        itemView: HeaderView,
        tagName: 'tr',

        collectionEvents: {
            //TODO: don't know why we need re-render when we are changing something in the column.
            //'change': 'render',
            'change:condition': 'render changeWidth'
        },

        itemViewEventPrefix: 'column:header',

        itemViewOptions: function() {
            return {
                filterProcessor: this.filterProcessor,
                sortable: this.sortable,
                filterable: this.filterable,
                resizable: this.resizable,
                draggable: this.draggable,
                defaultWidth: this.defaultColumnWidth,
                masterCollection: this.options.masterCollection,
                disableDynamicColumnWidths: this.options.disableDynamicColumnWidths,
                gridCid: this.gridCid,
                grid: this.grid
            };
        },

        initialize: function() {
            var options = this.options;

            this.sortableCollection = options.sortableCollection;
            this.filterProcessor = options.filterProcessor;
            this.clientSidePagination = options.clientSidePagination;
            this.layout = options.layout;
            this.sortMethod = options.sortMethod;
            this.sortable = options.sortable;
            this.filterable = options.filterable;
            this.resizable = options.resizable;
            this.draggable = options.draggable;
            this.stateModel = options.stateModel;
            this.defaultColumnWidth = options.defaultColumnWidth;
            this.gridCid = options.gridCid;
            this.grid = options.grid;
            this.enableColumnRename = options.enableColumnRename;

            this.initDefaultSort(options);
            this.initFilterListener(options.stateFilters);
        },


        delegateEvents: function() {
            CollectionView.prototype.delegateEvents.apply(this, arguments);

            this.listenTo(this, {
                'column:header:click': this.handleItemViewClick,
                'column:header:reorder': this.handleReorder
            });
        },

        /**
         * Makes columnHeader initialized, to listenTo grid filtering
         */
        initFilterListener: function(stateFilters) {
            if (stateFilters) {
                this.render();
            }
        },

        /**
         * Initializes any default sort on the grid if a default sort is setup.
         * Defaults to ascending sort order on the specified column if nothing is specified.
         *
         * @param opts The grid options.
         */
        initDefaultSort: function(opts) {
            var defaultSort = opts.defaultSort,
                sortCol,
                sortOrder;

            // need to clear previous sort.
            this.collection.each(this.clearSortedModel, this);
            if (defaultSort && defaultSort.field) {
                sortCol = this.collection.findWhere({
                    field: defaultSort.field
                });
                if (sortCol) {
                    sortOrder = defaultSort.order === 'desc' ? 'asc' : 'desc';
                    sortCol.set({
                        'sort': true, //turn on sorting for this column
                        'sorted': sortOrder //default to ascending sort if none supplied.  Set the opposite of what we want as applySimpleFieldSort reverses it
                    });

                    this.collection.each(this.applySimpleFieldSort, this);
                }
            }
        },

        handleReorder: function() {
            this.sortableCollection.trigger('change', this.sortableCollection);

            if (this.stateModel !== null) {
                this.stateModel.setColumnOrder(this.collection.toJSON());
            }

            this.render();
        },

        handleItemViewClick: function(event, view) {
            // If sorting is disabled at the grid-level, return early
            if (!this.options.sortable) {
                return;
            }

            // If sorting is disabled for this particular column, return early
            if (view.model.has('sortable') && view.model.get('sortable') === false) {
                return;
            }

            this.collection.each(this.clearSortedModel, this);

            view.model.set('sort', true, {
                silent: true
            });

            this.applySimpleFieldSort(view.model);

            if (this.clientSidePagination) {
                this.layout.triggerMethod('tableView:clientSidePagination:sort');
            }

            this.render();
        },

        clearSortedModel: function(model) {
            model.unset('sort', {
                silent: true
            });
        },

        applySimpleFieldSort: function(columnDef) {
            if (columnDef.get('sort')) {
                var comparator = columnDef.get('field'),
                    sorted = columnDef.get('sorted');

                if (util.isUndefined(sorted) || sorted === 'desc') {
                    columnDef.set('sorted', 'asc');
                    comparator = comparatorFactory.ascendingByField(columnDef.get('field'));
                } else {
                    columnDef.set('sorted', 'desc');
                    comparator = comparatorFactory.descendingByField(columnDef.get('field'));
                }

                if (this.stateModel !== null) {
                    var sort = {};

                    sort[columnDef.get('field')] = columnDef.get('sorted');

                    this.stateModel.set('sort', sort);
                }

                if (typeof this.sortMethod === 'function') {
                    return this.sortMethod(columnDef.get('field'), columnDef.get('sorted'));
                }

                this.sortableCollection.comparator = comparator;

                this.sortableCollection.each(function(row, index) {
                    row.gluStableSortIndex = index;
                });
                this.sortableCollection.sort({
                    comparator: comparator
                });

                return true;
            }
        },

        getItemView: function(item) {
            return item.get('headerView') || this.itemView;
        },

        addItemView: function(item, ItemView, index) {
            if (item.has('condition')) {
                var isFunction = util.isFunction(item.get('condition')) && item.get('condition')(item) === false;
                var isBoolean = util.isBoolean(item.get('condition')) && !item.get('condition');
                if (isFunction || isBoolean) {
                    return false;
                }
            }
            return CollectionView.prototype.addItemView.call(this, item, ItemView, index);
        },

        // re-calculate the width when a columns get's added or removed
        changeWidth: function() {
            if (this.grid) {
                this.grid.trigger('grid:contentRendered');
            }
        }
    });
});

